/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class ServeService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Serve Image
     * @returns string Successful Response
     * @throws ApiError
     */
    public serveImageApiV1ServeUuidGet({
        uuid,
        imagesToken,
    }: {
        uuid: string,
        imagesToken?: string,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/serve/{uuid}',
            path: {
                'uuid': uuid,
            },
            query: {
                'images_token': imagesToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Serve Thumbnail
     * @returns string Successful Response
     * @throws ApiError
     */
    public serveThumbnailApiV1ServeThumbsWXHUuidGet({
        uuid,
        w,
        h,
        imagesToken,
    }: {
        uuid: string,
        w: string,
        h: string,
        imagesToken?: string,
    }): CancelablePromise<string> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/serve/thumbs/{w}x{h}/{uuid}',
            path: {
                'uuid': uuid,
                'w': w,
                'h': h,
            },
            query: {
                'images_token': imagesToken,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
